import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Sponsors',
  attributeName: 'sponsors',
  fields: [
     {
      attributeName: 'skippable',
      helpText: ' Sponsor can be skkiped',
      type: FormInputTypes.CHECKBOX,
      label: 'Skippable',
      placeholder: 'Is skippable',
      default: false,
    },
    {
      attributeName: 'visible',
      label: 'Visible',
      type: FormInputTypes.CHECKBOX,
      helpText: 'Indicate if sponsors is visible',
      placeholder: 'is Visible',
      default: true,
    },
  ],
};
